export const DEFAULT_COLS = [
  'DATE',
  'ACCOUNT_NAME',
  'TAGS',
  'DESCRIPTION',
  'AMOUNT',
]
